var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "36px",
    viewBox: "0 0 26 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sidenav",
    transform: "translate(-35.000000, -50.000000)",
    fill: "#F06C00"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.478538,57.7947938 C41.478538,55.0835611 44.1049723,53.3890408 47.4317891,53.3890408 C50.4084147,53.3890408 52.6846578,54.405753 54.9609008,56.1002734 C55.6612833,56.6086295 56.0114746,56.7780815 56.5367614,56.7780815 C57.2371439,56.7780815 57.4122395,56.4391774 57.4122395,55.9308213 L57.4122395,52.5417806 C57.4122395,52.0334245 57.2371439,51.6945204 56.711857,51.5250683 C54.6107096,50.8472602 51.1087972,50 47.2566935,50 C39.3773905,50 35,54.7446571 35,59.9976702 C35,71.6898609 53.5601359,69.1480803 53.5601359,77.1123261 C53.5601359,81.8569832 46.3812154,85.2460239 38.1517212,79.6541067 C37.4513387,79.1457506 37.1011475,78.8068465 36.400765,78.8068465 C35.3501912,78.8068465 35.1750956,79.3152026 35.1750956,79.8235587 L35.1750956,82.7042434 C35.1750956,83.2125995 35.3501912,83.5515035 35.8754781,83.8904076 C45.8559285,88.4656126 60.0386739,85.75438 60.0386739,74.2316414 C60.3888651,63.556163 41.478538,64.2339712 41.478538,57.7947938 L41.478538,57.7947938 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSLogo);
export default __webpack_public_path__ + "static/media/s-logo.5c9d6816d289bec8430b8fce16ad05a0.svg";
export { ForwardRef as ReactComponent };